import { setMessagesFailed, setMessagesFulfilled, setMessagesPending } from './actions';
import { fetchHistoryMessages } from '../../services/fetchHistoryMessages';
import { ERequestApiStatus } from '../../types/appState';
import { TMessageSchema } from '../../types/messages';
import { TThunkAction } from '../../types/redux/thunk';
import { ERequestSource, TRequestSource, getRequestDiagnostics } from '../../utils/logging/publicApiDiagnostics';

/**
 * Запрос сообщений по http
 */
export const getMessages =
  (chatId: string, source: TRequestSource = ERequestSource.Unknown): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const {
      custom: { messagesMap },
    } = context;

    const state = getState();

    const { openedChats } = state;

    const chat = openedChats[chatId];

    if (chat && chat.status === ERequestApiStatus.Pending) {
      return;
    }

    const createdAt = chat && chat.currentTimestamp ? new Date(chat.currentTimestamp).toISOString() : undefined;

    dispatch(setMessagesPending({ chatId }));

    const result = await fetchHistoryMessages(context, {
      parameters: {
        chatId,
        createdAt,
      },
      source,
      diagnostics: getRequestDiagnostics(state, context),
    });

    const { error, response } = result;

    if (response !== null) {
      dispatch(
        setMessagesFulfilled({ chatId, messages: response.messages as unknown as TMessageSchema[], messagesMap }),
      );

      return;
    }

    dispatch(setMessagesFailed({ chatId, error }));
  };
